<template>
  <!-- Draws the session sheets opened with sessionSheets.open(kind,
       session) from a row's menu: Duplicate (ForkDialog), Report session
       (ReportDialog) and Invite (InviteDialog), so no pane mounts its own
       copies. A duplicate lands at the top of Mine. -->
  <ForkDialog
    v-if="kind === 'fork' && session"
    :key="`f${state.seq}`"
    v-model:show="show"
    :session-name="session.name"
    :display-name="title"
    @forked="onForked"
  />
  <ReportDialog
    v-if="kind === 'report' && session"
    :key="`r${state.seq}`"
    v-model:show="show"
    target-type="session"
    :target-id="session.name"
    :target-label="title"
  />
  <InviteDialog v-if="kind === 'invite' && session" :key="`i${state.seq}`" ref="invite" :session-name="session.name" />
</template>

<script>
import ForkDialog from "@/components/ForkDialog.vue";
import ReportDialog from "@/components/ReportDialog.vue";
import InviteDialog from "@/components/InviteDialog.vue";
import sessionLists from "@/stores/sessionLists.js";
import { rowTitle } from "@/kit/sessionRow.js";
import { sessionSheetState, close } from "./sessionSheets.js";

export default {
  name: "SessionSheetsHost",
  components: { ForkDialog, ReportDialog, InviteDialog },
  data: () => ({ state: sessionSheetState }),
  computed: {
    kind() {
      return this.state.kind;
    },
    session() {
      return this.state.session;
    },
    title() {
      return this.session ? rowTitle(this.session) : "";
    },
    show: {
      get() {
        return !!this.state.kind;
      },
      set(v) {
        if (!v) close();
      },
    },
  },
  watch: {
    "state.seq"() {
      if (this.kind === "invite") this.$nextTick(() => this.$refs.invite?.open?.());
    },
  },
  methods: {
    onForked(row) {
      if (row && row.name) sessionLists.upsert(row, "mine");
    },
  },
};
</script>
